import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidatePassword } from '../validate-password.service';
import { AdminService } from '../admin.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  changePasswordForm: FormGroup;
  username: string;

  constructor(private adminService: AdminService,
              private bsModalRef: BsModalRef,
              private fb: FormBuilder) {
  }

  ngOnInit() {
    this.changePasswordForm = this.fb.group({
        username: new FormControl({value: this.username, disabled: true}),
        password: new FormControl('', [Validators.required, Validators.minLength(4)]),
        passwordAgain: new FormControl('', [Validators.required, Validators.minLength(4)]),
      }, {
        validators: [ValidatePassword.validate]
      }
    );
  }

  changePassword() {
    if (this.changePasswordForm.invalid) {
      return;
    }
    this.adminService.changePassword(this.changePasswordForm.getRawValue()).subscribe(() => {
      this.bsModalRef.hide();
    });
  }

  cancelNewUserModal() {
    this.bsModalRef.hide();
  }

}
